module.exports = {"TXTCLI_Free_Spins":{"id":"TXTCLI_Free_Spins","defaultMessage":"Δωρεάν περιστροφές","track":"Free Spins"}}